var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "panel-basemaps",
      class: [_vm.baseClass, { "panel-show": _vm.show }],
      style: {
        top: `${_vm.position.top}`,
        left: `${_vm.position.left}`,
        bottom: `${_vm.position.bottom}`,
        right: `${_vm.position.right}`,
      },
      on: { mouseleave: _vm.onMouseLeave },
    },
    [
      _c("div", { staticClass: "d-flex flex-column basemaps-container" }, [
        _vm.hasOverLayers()
          ? _c("div", { staticClass: "d-flex flex-column overlayers" }, [
              _c("span", { staticClass: "header d-none" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.idPanel}.help.overlayer.title`)) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row no-gutters" },
                _vm._l(_vm.overLayers(), function (layer, index) {
                  return _c(
                    "div",
                    { key: `overlayer-${index}`, staticClass: "col-6 col-sm" },
                    [
                      _c(
                        "label",
                        {
                          class: [
                            "card-group-toggle",
                            {
                              active: (_vm.form.overlayers ?? []).includes(
                                layer.get("id")
                              ),
                            },
                          ],
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.overlayers,
                                expression: "form.overlayers",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: `overlayer-${layer.get("id")}`,
                              id: `overlayer-${layer.get("id")}`,
                            },
                            domProps: {
                              value: layer.get("id"),
                              checked: Array.isArray(_vm.form.overlayers)
                                ? _vm._i(_vm.form.overlayers, layer.get("id")) >
                                  -1
                                : _vm.form.overlayers,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.form.overlayers,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = layer.get("id"),
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "overlayers",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "overlayers",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "overlayers", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("img", {
                                staticClass: "small",
                                attrs: {
                                  src: layer.get("img"),
                                  alt: layer.get("name"),
                                  title: layer.get("tooltip"),
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(layer.get("name")) +
                                    "\n                                    "
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column baselayers" }, [
          _c("span", { staticClass: "header separator d-none" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t(`${_vm.idPanel}.help.baselayer.title`)) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row no-gutters" },
            _vm._l(_vm.baseLayers(), function (layer, index) {
              return _c(
                "div",
                { key: `baselayer-${index}`, staticClass: "col-6 col-sm" },
                [
                  _c(
                    "label",
                    {
                      class: [
                        "card-group-toggle",
                        { active: _vm.form.baselayer_id == layer.get("id") },
                      ],
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.baselayer_id,
                            expression: "form.baselayer_id",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          name: "baselayer_id",
                          id: `baselayer-${layer.get("id")}`,
                        },
                        domProps: {
                          value: layer.get("id"),
                          checked: _vm._q(
                            _vm.form.baselayer_id,
                            layer.get("id")
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.$set(_vm.form, "baselayer_id", layer.get("id"))
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("img", {
                            attrs: {
                              src: layer.get("img"),
                              alt: layer.get("name"),
                              title: layer.get("tooltip"),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(layer.get("name")) +
                                "\n                                    "
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("hr", { staticClass: "my-2" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }